import styled from "styled-components";

const TotleScore = ({score}) => {
  return (
    <ScoreContainer>
      <h3>{score}</h3>
      <p>Total Score</p>
    </ScoreContainer>
  );
};
export default TotleScore;

const ScoreContainer = styled.div`
  border: 1px solid #111;
  padding:10px;
  width:140px;
  height:100px;
  text-align:center;
  h3 {
    font-size: 60px;
    margin: 0;
    line-height:1;
  }
  p {
    margin: 0;
    font-size: 20px;
    font-weight: 700px;
  }
`;
